export default "__VITE_ASSET__BtcLuo01__"